module.exports = __webpack_public_path__ + "static/media/OpenSans-Regular.5885cdcb.woff2";